import React from 'react';
import { blockStyle, labelStyle, inputStyle, styles } from './trainAgentStyles';

export function TrainAgentCompanyBlock({ vm }) {
  const {
    companyInfo,
    setCompanyInfo,
    companyInfoFiles,
    companyInfoUrls,
    uploadFile,
    setUploadFile,
    handleUpload,
    handleRemoveFile,
    uploading,
    addCompanyUrl,
    removeCompanyUrl,
    setCompanyUrl
  } = vm;

  return (
    <div style={blockStyle}>
      <label style={labelStyle}>4. Informações da Empresa (companyInfo)</label>
      <textarea
        value={companyInfo}
        onChange={(e) => setCompanyInfo(e.target.value)}
        rows={4}
        style={{ ...inputStyle, resize: 'vertical' }}
        placeholder="Texto sobre a empresa, produtos, serviços"
      />
      <label style={{ ...labelStyle, marginTop: '16px' }}>Arquivos (.txt, .docx, .pdf) — opcional</label>
      {companyInfoFiles.length > 0 && (
        <ul style={{ margin: '8px 0', paddingLeft: '20px', color: '#B0BEC5', fontSize: '13px', listStyle: 'none' }}>
          {companyInfoFiles.map((f, i) => (
            <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
              <span>
                {f.fileName} — {f.uploadedAt ? new Date(f.uploadedAt).toLocaleDateString() : ''}
              </span>
              <button type="button" onClick={() => handleRemoveFile(i)} style={styles.removeBtn} title="Excluir arquivo">
                − Excluir
              </button>
            </li>
          ))}
        </ul>
      )}
      <form onSubmit={handleUpload} style={{ display: 'flex', gap: '12px', alignItems: 'center', marginTop: '8px' }}>
        <input
          type="file"
          accept=".txt,.docx,.doc,.pdf"
          onChange={(e) => setUploadFile(e.target.files[0] || null)}
          style={{ ...inputStyle, flex: 1, padding: '8px' }}
        />
        <button type="submit" style={styles.smallButton} disabled={uploading || !uploadFile}>
          {uploading ? 'Enviando...' : 'Enviar arquivo'}
        </button>
      </form>
      <label style={{ ...labelStyle, marginTop: '20px' }}>Sites e páginas para treino (opcional)</label>
      <p style={{ color: '#B0BEC5', fontSize: '13px', marginBottom: '10px' }}>
        Informe URLs de páginas web. O conteúdo será buscado e usado como base de conhecimento do bot.
      </p>
      {companyInfoUrls.map((url, i) => (
        <div key={i} style={{ display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'center' }}>
          <input
            type="url"
            value={url}
            onChange={(e) => setCompanyUrl(i, e.target.value)}
            placeholder="https://exemplo.com/pagina"
            style={{ ...inputStyle, flex: 1 }}
          />
          <button type="button" onClick={() => removeCompanyUrl(i)} style={styles.removeBtn}>
            −
          </button>
        </div>
      ))}
      <button type="button" onClick={addCompanyUrl} style={styles.smallButton}>
        + Adicionar site ou página
      </button>
    </div>
  );
}
